import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import gibletLogo from '@/assets/giblet-logo.png';

export default function DemoCallForKnowledgeRewards() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  const bountyAmount = state.bountyAmount || 6700;
  const creatorPct = state.creatorPct || 50;
  const contributorPct = state.contributorPct || 45;
  const confirmerPct = state.confirmerPct || 5;

  const creatorAmount = bountyAmount * (creatorPct / 100);
  const contributorAmount = bountyAmount * (contributorPct / 100);
  const confirmerAmount = bountyAmount * (confirmerPct / 100);

  const kbTitle = state.kbTitle || 'Construction Safety Standards KB';
  const connectedToCfS = state.connectedToCfS;
  const cfsTitle = state.selectedCfSTitle;
  const cfsBounty = state.selectedCfSBounty;

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="max-w-2xl w-full space-y-8">
        <div className="flex justify-center mb-8">
          <img src={gibletLogo} alt="Giblet Logo" className="h-16 w-auto" />
        </div>

        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold text-foreground">Knowledge Bounty Rewards Distribution</h1>
          <p className="text-lg text-muted-foreground">{kbTitle}</p>
        </div>

        <div className="bg-card rounded-lg p-8 shadow-lg space-y-6">
          {connectedToCfS && cfsBounty && (
            <div className="bg-muted/50 rounded-lg p-4 space-y-1 text-sm">
              <div className="font-semibold text-foreground">Connected CfS: {cfsTitle}</div>
              <div className="text-muted-foreground">
                Total Solution Bounty: ${cfsBounty.toLocaleString()} → Creation Team Share (67%): <span className="font-bold text-foreground">${bountyAmount.toLocaleString()}</span>
              </div>
            </div>
          )}

          <div className="text-center">
            <div className="text-sm text-muted-foreground">CURT Knowledge Team Reward</div>
            <div className="text-4xl font-bold text-foreground">${bountyAmount.toLocaleString()}</div>
          </div>

          <div className="space-y-3">
            <div className="flex items-center justify-between p-4 bg-primary/10 rounded-lg">
              <div>
                <div className="font-semibold text-foreground">Creator</div>
                <div className="text-sm text-muted-foreground">Karen Watson — Knowledge Base lead author</div>
              </div>
              <div className="text-right">
                <div className="font-bold text-foreground">${creatorAmount.toLocaleString()}</div>
                <div className="text-xs text-muted-foreground">{creatorPct}%</div>
              </div>
            </div>

            <div className="flex items-center justify-between p-4 bg-primary/10 rounded-lg">
              <div>
                <div className="font-semibold text-foreground">Contributor</div>
                <div className="text-sm text-muted-foreground">Corey Vickers — Domain expert contributor</div>
              </div>
              <div className="text-right">
                <div className="font-bold text-foreground">${contributorAmount.toLocaleString()}</div>
                <div className="text-xs text-muted-foreground">{contributorPct}%</div>
              </div>
            </div>

            <div className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
              <div>
                <div className="font-semibold text-foreground">Confirmer</div>
                <div className="text-sm text-muted-foreground">Giblet — AI validation & quality assurance</div>
              </div>
              <div className="text-right">
                <div className="font-bold text-foreground">${confirmerAmount.toLocaleString()}</div>
                <div className="text-xs text-muted-foreground">{confirmerPct}%</div>
              </div>
            </div>
          </div>

          <div className="bg-muted/30 rounded-lg p-4 text-sm text-muted-foreground space-y-1">
            <div className="font-semibold text-foreground">Release Conditions</div>
            <ul className="list-disc list-inside space-y-1">
              <li>Knowledge Base confirmed and validated by Confirmer</li>
              <li>All acceptance criteria met and peer-reviewed</li>
              <li>KB minted on-chain with proper attribution</li>
              <li>Bounty released from escrow via smart contract</li>
            </ul>
          </div>
        </div>

        <div className="flex justify-center">
          <Button onClick={() => navigate('/curt-channel')} className="min-w-[200px]">
            Back to CURT Channel
          </Button>
        </div>
      </div>
    </div>
  );
}
